import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import {
  formatCounterAmount,
  isHourlyFixedBalanceAllowance,
} from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

import type Allowance from 'modules/timeoff/store/models/Allowance'

interface Props {
  amount: number
  text: string
  remainder: number
  allowance: Allowance
}

const Section = ({ text, amount, remainder, allowance }: Props) => {
  const showRemainder = allowance.isDays
    ? i18n.t('time_off.tooltip_common.remainder.days', {
        remainder,
      })
    : i18n.t('time_off.tooltip_common.remainder.hours', {
        remainder,
      })

  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal>{text}</Text.Normal>
        <Text.Normal>
          {formatCounterAmount(amount, isHourlyFixedBalanceAllowance(allowance))}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="flexStart">
        <Text.Normal size="200">{showRemainder}</Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(Section)
